import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '', full_name: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await register(formData.email, formData.password, formData.full_name);
      toast.success('Account created successfully!');
      navigate('/videos');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <Navbar />
      
      <div className="max-w-md mx-auto px-4 py-24">
        <div className="bg-slate-900 p-8 rounded-sm border border-slate-800">
          <h1 
            data-testid="register-heading"
            className="text-3xl font-bold mb-8 text-center"
            style={{ fontFamily: 'Oswald, sans-serif', textTransform: 'uppercase' }}
          >
            Create Account
          </h1>
          
          <form onSubmit={handleSubmit} data-testid="register-form" className="space-y-6">
            <div>
              <Label htmlFor="full_name" className="text-white mb-2 block">Full Name</Label>
              <Input
                id="full_name"
                data-testid="name-input"
                type="text"
                value={formData.full_name}
                onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 h-12 rounded-sm"
                placeholder="John Doe"
                required
              />
            </div>
            
            <div>
              <Label htmlFor="email" className="text-white mb-2 block">Email</Label>
              <Input
                id="email"
                data-testid="email-input"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 h-12 rounded-sm"
                placeholder="your@email.com"
                required
              />
            </div>
            
            <div>
              <Label htmlFor="password" className="text-white mb-2 block">Password</Label>
              <Input
                id="password"
                data-testid="password-input"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 h-12 rounded-sm"
                placeholder="••••••••"
                required
                minLength={6}
              />
            </div>
            
            <Button 
              data-testid="register-submit-button"
              type="submit" 
              disabled={loading}
              className="w-full bg-red-600 hover:bg-red-700 text-white h-12 rounded-sm font-bold"
              style={{ fontFamily: 'Oswald, sans-serif', textTransform: 'uppercase' }}
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </Button>
          </form>
          
          <p className="text-center text-slate-400 mt-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Already have an account?{' '}
            <Link to="/login" className="text-red-500 hover:text-red-400">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
